import React from 'react';
import { Box, makeStyles, Typography } from '@material-ui/core';
import PieChart from 'components/@common/Charts/PieChart';
import ChartLayout from './ChartLayout';
// import InfoIcon from '@material-ui/icons/Info';
import { PrmCurriculumProgressReportResult } from 'types/schema-generated-types';

type Props = {
  prmCurriculumProgressReport?: PrmCurriculumProgressReportResult;
};

const OverallProgressChart: React.FC<Props> = ({ prmCurriculumProgressReport }) => {
  const classes = useStyles();

  const overallProgressPercentage = prmCurriculumProgressReport?.overallProgressPercentage ?? 0;
  const calcOverallPercent = (overallProgressPercentage: number) => {
    return overallProgressPercentage ? Math.round(overallProgressPercentage) : 0;
  };
  return (
    <ChartLayout
      Left={
        <PieChart
          type="radialBar"
          series={[calcOverallPercent(overallProgressPercentage)]}
          height={250}
          options={{
            tooltip: {
              y: {
                formatter: (data: any) => `${data}%`,
                title: {
                  formatter: () => 'Overall Progress:'
                }
              }
            },
            stroke: {
              lineCap: 'round'
            },
            plotOptions: {
              radialBar: {
                dataLabels: {
                  name: {
                    fontSize: '22px'
                  },
                  value: {
                    fontSize: '40px',
                    offsetY: -10
                  },
                  total: {
                    show: true,
                    label: ''
                  }
                }
              }
            },
            colors: ['#338AC6']
          }}
        />
      }
      Right={
        <>
          <Box display="flex">
            <Typography className={classes.title}>Overall Curriculum Progress </Typography>
            {/* <InfoIcon className={classes.infoIcon} /> */}
          </Box>
          <Typography variant="h3">{calcOverallPercent(overallProgressPercentage)}%</Typography>
        </>
      }
    />
  );
};

const useStyles = makeStyles(theme => ({
  title: {
    fontSize: 18
  },
  infoIcon: {
    height: 16,
    width: 16,
    paddingTop: theme.spacing() / 2,
    color: theme.palette.secondary.main,
    alignSelf: 'center'
  }
}));
export default OverallProgressChart;
